import { FC, ReactNode, HTMLProps } from "react"
import classNames from "classnames"

interface Props extends Omit<HTMLProps<HTMLInputElement>, "label" | "onChange" | "id" | "checked" >{
  checked: boolean
  id?: string
  label?: ReactNode
  onChange?(): void
  className?: string
  containerClassName?: string
}

const Checkbox: FC<Props> = ({
  label,
  checked,
  id,
  onChange,
  className,
  containerClassName,
  ...props
}) => {
  return (
    <div className={classNames("checkbox__container", containerClassName)}>
      <label htmlFor={id}>{label}</label>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className={classNames("checkbox__input", className)}
        {...props}
      />
    </div>
  )
}

export default Checkbox
